// Videollamada

export const PERMISO_TRAMITAR_VIDEOLLAMADA = [
  'videollamada',
  'tramitar_videollamada',
];
